import React from 'react'
import { Field } from 'react-final-form'
import './PbtCustomVideo.scss'
import { Message } from 'semantic-ui-react'

interface PbtCustomVideoProps {
  imageAdapter: any
  showDestroy: boolean
  hasError: boolean
}

const PbtCustomVideo = ({ imageAdapter, showDestroy, hasError }: PbtCustomVideoProps) => {
  return (
    <div className="pbtCustomVideoCtr">
      <h2>Custom Video</h2>
      {hasError && (
        <Message negative>
          <p>Must set overlay image and video URL</p>
        </Message>
      )}
      <div className="field">
        <label>Position</label>
        <Field
          name="pbt_custom_video_attributes.position"
          component="input"
          type="number"
          defaultValue={5}
          disabled={true}
          required={true}
        />
      </div>
      <div className="field">
        <label>Overlay Text</label>
        <Field component="input" name={`pbt_custom_video_attributes.overlay_text`} type="text" />
      </div>
      <div className="field">
        <label>Overlay Image URL (required)</label>
        <Field
          isBrandLogo={false}
          name={`pbt_custom_video_attributes.overlay_image_url`}
          type="text"
          component={imageAdapter}
        />
      </div>
      <div className="field">
        <label>Video URL (required)</label>
        <Field component="input" name={`pbt_custom_video_attributes.video_url`} type="text" />
      </div>
      {showDestroy && (
        <div className="field">
          <label>Delete</label>
          <Field component="input" name={`pbt_custom_video_attributes._destroy`} type="checkbox" />
        </div>
      )}
    </div>
  )
}

export default PbtCustomVideo
